export * from './Slider';
//# sourceMappingURL=index.js.map